export default __webpack_public_path__ + "static/media/13.190c91eb.png";